var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      readonly: _vm.form.estado != "N",
                      id: "code",
                      placeholder: "##"
                    },
                    model: {
                      value: _vm.form.subcode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "subcode", $$v)
                      },
                      expression: "form.subcode"
                    }
                  },
                  [
                    _c("span", [_vm._v("Subcode")]),
                    _vm._v(" "),
                    _vm.errores.subcode
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.subcode[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: { id: "code", placeholder: "##" },
                    model: {
                      value: _vm.form.code,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "code", $$v)
                      },
                      expression: "form.code"
                    }
                  },
                  [
                    _c("span", [_vm._v("Code")]),
                    _vm._v(" "),
                    _vm.errores.code
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [_c("strong", [_vm._v(_vm._s(_vm.errores.code[0]))])]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "customer_code",
                      options: _vm.customers,
                      label: "name"
                    },
                    on: { input: _vm.inputCustomer },
                    model: {
                      value: _vm.selectedCustomer,
                      callback: function($$v) {
                        _vm.selectedCustomer = $$v
                      },
                      expression: "selectedCustomer"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "customer_code" } }, [
                    _vm._v("Cliente")
                  ]),
                  _vm._v(" "),
                  _vm.errores.customer_code
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.customer_code[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.aceptar }
        },
        [
          _c("i", { staticClass: "fa fa-save" }),
          _c("span", [_vm._v("Guardar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cancelar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-ban" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Stowage")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4250acd4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4250acd4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/stowage/Stowage.vue
// module id = 403
// module chunks = 0